// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalView_modal__Naoaa","a-modal-background":"ModalView_a-modal-background__a8Tbu","close-button":"ModalView_close-button__t3r09"};